/**
 * Add application routes here
 */
export default [
  {
    path: '/',
    component: () => import('modules/core/components/App.vue'),
    children: [
      {
        name: 'dashboard',
        path: '',
        redirect: '/step-tracker',
        component: () => import('modules/dashboard/components/Dashboard.vue'),
      },
      {
        name: 'devices',
        path: '/devices',
        component: () => import('modules/devices/components/List.vue'),
      },
      {
        name: 'devices.add',
        path: '/devices/add',
        component: () => import('modules/devices/components/Add.vue'),
      },
      {
        name: 'apiKeys',
        path: '/api-keys',
        component: () => import('modules/api-keys/components/List.vue'),
      },
      {
        name: 'invoices',
        path: '/invoices',
        component: () => import('modules/invoices/components/List.vue'),
      },
      {
        name: 'calls',
        path: '/calls',
        component: () => import('modules/calls/components/List.vue'),
      },
      {
        name: 'payment',
        path: '/payment',
        component: () => import('modules/payments/components/Payment.vue'),
      },
      {
        name: 'billing',
        path: '/billing',
        component: () => import('modules/billing/components/Billing.vue'),
      },
      {
        name: 'profile',
        path: '/profile',
        component: () => import('modules/profile/components/Profile.vue'),
      },
      {
        name: 'contact',
        path: '/contact',
        component: () => import('modules/contact/components/Contact.vue'),
      },
      {
        name: 'properties',
        path: '/properties',
        component: () => import('modules/properties/components/Properties.vue'),
      },
      {
        name: 'integrations',
        path: '/integrations',
        component: () => import('modules/integrations/components/List.vue'),
      },
      {
        name: 'integration',
        path: '/integration',
        component: () => import('modules/integrations/components/Integration.vue'),
      },
      {
        name: 'plan',
        path: '/plan',
        component: () => import('modules/plan/components/Plan.vue'),
      },
      {
        name: 'payment-settings',
        path: '/payment-settings',
        component: () => import('modules/payment-settings/components/PaymentSettings.vue'),
      },
      {
        name: 'search-contact',
        path: '/search-contact',
        component: () => import('modules/search-contact/components/SearchContacts.vue'),
      },
      {
        name: 'step-tracker',
        path: '/step-tracker',
        component: () => import('modules/profile/components/StepTracker.vue'),
      },
    ],
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('modules/auth/components/Login.vue'),
  },
  {
    name: 'logout',
    path: '/logout',
    component: () => import('modules/auth/components/Logout.vue'),
  },
  {
    name: 'register',
    path: '/register',
    component: () => import('modules/auth/components/Register.vue'),
  },
  {
    name: 'reset-password',
    path: '/reset-password',
    component: () => import('modules/auth/components/ResetPassword.vue'),
  },
  {
    name: 'set-new-password',
    path: '/set-new-password/:userId/:token(.*)',
    component: () => import('modules/auth/components/SetNewPassword.vue'),
  },
  {
    name: 'installation-wizard',
    path: '/install',
    component: () => import('modules/installation-wizard/components/Wizard.vue'),
  },
  {
    name: 'install-summary',
    path: '/install-summary',
    component: () => import('modules/installation-wizard/components/Wizard.vue'),
  },
  {
    name: 'select-account',
    path: '/select-account',
    component: () => import('modules/select-account/components/SelectAccount.vue'),
  },
  {
    name: 'redirect-from-mobile',
    path: '/redirect-from-mobile',
    component: () => import('modules/redirect-from-mobile/components/RedirectFromMobile.vue'),
  },
  {
    name: 'redirect-to-integration',
    path: '/redirect-to-integration/:integration',
    component: () => import('modules/redirect-to-integration/components/RedirectToIntegration.vue'),
  },
  {
    name: 'help',
    path: '/help',
    component: () => import('modules/help/components/Help.vue'),
  },
  // Always leave this last one
  {
    path: '*',
    component: () => import('modules/core/components/HelloWorld.vue'),
  }, // Not found
];
